import React, { useState, useEffect, useRef } from "react";
import "./navbar.css";
import inoxLogo from "../../../assets/brand/inox-logo.png";
import pvrLogo from "../../../assets/brand/pvr-logo.svg";
import { Toast } from "primereact/toast";
import { useNavigate,useLocation  } from "react-router-dom";
import showtime from "../../../assets/nav-icon/showtime.svg";
import cinema from "../../../assets/nav-icon/Cinema.svg";
import offerBlack from "../../../assets/nav-icon/offer_black.svg";
import offerWhite from "../../../assets/nav-icon/offer_white.svg";
import home from "../../../assets/nav-icon/home.svg";
import homeB from "../../../assets/nav-icon/home_black.svg";
import PassportWhite from "../../../assets/nav-icon/passport_white.svg";
import PassportBlack from "../../../assets/nav-icon/passport_black.svg";
import showtime_White from "../../../assets/nav-icon/showtime_white.svg";
import cinema_White from "../../../assets/nav-icon/cinema_white.svg";
import searchm from "../../../assets/nav-icon/search.svg";
import profile from "../../../assets/nav-icon/profile-icon.svg";
import { setViewMode as setViewModelogin } from "src/redux/actions/viewModeActions";
import custoArrowB from "../../../assets/cities/black-cities.svg";
import Cities from "../cities/Cities";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import "primeicons/primeicons.css";
import "./navbar.css";
import { LoginButton } from "./navbarTags";
import Login from "../login/Login";
import { Dialog } from "primereact/dialog";
import { useSelector, useDispatch } from "react-redux";
import { setLoginViewMode } from "../../../redux/actions/loginViewAction";
import SweetAlert from "react-bootstrap-sweetalert";
import MoreDropdown from "./more-dropdown/MoreDropdown";
import Search from "./search/Search";
import user from "../../../assets/nav-icon/user.svg";
import { DarkButton } from "src/styled-components/customButtons";
import { hitGa } from "src/services/PassportServices";
import { loginViewMode } from "src/redux/reducers/loginViewReducer";
//import { Dialog } from "primereact/dialog";

const Navbar = () => {
  // const isMobile = window.matchMedia('(max-width: 575px)').matches;
  const toast = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const theme = localStorage.getItem("theme");
  const trailerViewModde = useSelector((state) => state.trailerViewMode.value);
  const [visible, setVisible] = useState(trailerViewModde);
  const currentPath = window.location.pathname.split("/");
  const [errorMsg, setShowMsg] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  const loginVewMode = useSelector((state) => state.loginViewMode.value);
  const [logoutModal, setLogoutModal] = useState(false);
  

  // console.log("currentPath", currentPath);

  useEffect(() => {
    if (trailerViewModde !== 0) {
      setVisible(false);
    }
  }, [trailerViewModde]);


  const activeCurrentPathVal =
    currentPath[1] === ""
      ? 0
      : currentPath[1] === "show-time"
        ? 1
        : currentPath[1] === "cinemas" ||
          currentPath[1] === "cinemasessions" ||
          currentPath[1] === "experience"
          ? 2
          : currentPath[1] === "offers"
            ? 3
            : currentPath[1] === "passport"
              ? 4
              : currentPath[1] === "moviesessions"
                ? 6
                : currentPath[1] === "seatlayout"
                  ? 7
                  : currentPath[1] === "getfood"
                    ? 8
                    : currentPath[1] === "payment"
                      ? 9
                      : 5;
  const [buttonView, setButtonView] = useState(activeCurrentPathVal);
  const [menuHide, setMenuHide] = useState(false);
  const [visibleRight, setVisibleRight] = useState(false);

  // const hitGa = (event) => {
  //   let dataLayer = window["dataLayer"] || [];
  //   dataLayer.push(event);
  // };
  const logoutService = async () => {
    //setLoading(true);
    const postData = {
      mobile: loginInfo?.data?.mob,
      refreshToken: localStorage.getItem("refrace_token"),
    };
    setLogoutModal(false);
    setShowAlert(true);
    setShowMsg({ title: "Success", msg: "You are logged out successfully" });
    hitGa({
      'event': 'passport_log_out'
    })
    localStorage.removeItem("loginInfo");
    localStorage.removeItem("token");
    localStorage.removeItem("refrace_token");
    dispatch(setViewModelogin(Math.floor(10000 + Math.random() * 90000)));
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // console.log('isMobile >>>>>>', isMobile);

  return (
    <>
      <SweetAlert
          success
          show={showAlert}
          title={errorMsg?.result === "dialog" ? "Oops" : errorMsg?.result}
          onConfirm={() => {
            setShowAlert(false);
            // console.log('confirm')
            //navigate('/')
          }}
          onCancel={() => setShowAlert(false)}
          confirmBtnCssClass={
            theme === "inoxTheme"
              ? "confirm-btn-inox border-0"
              : "confirm-btn-pvr border-0"
          }
        >
          {errorMsg?.msg}
        </SweetAlert>
        <div className="card flex justify-content-center">
          <Dialog
            visible={logoutModal}
            showHeader={false}
            showCloseIcon={false}
            className="seat-terms-condition-flow"
            style={{ width: "30vw" }}
            onHide={() => setLogoutModal(false)}
          >
            <div className="card px-3 pt-2">
              <div className="d-flex justify-content-center">
                <span>Are you sure to want to logout?</span>
              </div>
              <div className="accpet-btn-flow-seat">
                <DarkButton
                  className="reject-terms my-2 m-3"
                  onClick={() => {
                    setLogoutModal(false);
                  }}
                >
                  No
                </DarkButton>
                <DarkButton
                  className="reject-terms my-2"
                  onClick={() => {
                    logoutService();
                  }}
                >
                  Yes
                </DarkButton>
              </div>
            </div>
          </Dialog>
        </div>
      {!isMobile ? (
        <>
        <div className="desktop-view-M show-in-desktop-view">
          <div style={{ height: "3.4rem" }}>
            <Toast ref={toast}></Toast>
            <div className="d-flex justify-content-between nav-center nav-mt">
              <div className="d-flex mx-3">
                <span>
                   <Cities />
                </span>
              </div>
              <div className="d-flex">
                {/* <Search /> */}
                <div className="mx-2 now-right">
                {loginInfo ?
                  <button
                    className={
                      theme === "inoxTheme"
                         ? "bg-light-inox logout-profile"
                         : "bg-light-pvr logout-profile"
                   }
                    onClick={() => {
                      // console.log("logout");
                      setLogoutModal(true);
                      //hitGa("log_out");

                    }}
                  >
                    <span className="profile-icons">
                          <img src={profile} alt="" className="img-fluid" />
                    </span>
                    Logout
                  </button>
                :""}
                </div>
                <div className="login-before">
                  <LoginButton
                    className="before-login"
                    onClick={() => {
                      // console.log("loginInfo", loginInfo);
                      if (loginInfo?.data?.mob) {
                        //navigate("/profile");
                      } else {
                        dispatch(setLoginViewMode({ value: true }));
                      }
                    }}
                  >
                    {loginInfo && loginInfo ? (
                      `Hey, ${loginInfo?.data?.un?.length > 9
                        ? `${loginInfo?.data?.un?.substr(0, 9)}...`
                        : loginInfo?.data?.un
                      }` 
                    ) : (
                      <>
                        <span className="profile-icons">
                          <img src={profile} alt="" className="img-fluid" />
                        </span>
                        Login
                      </>
                    )}
                  </LoginButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
      ) : (
        <div className="head-mobile-view-m show-in-mobile-view">
          <div className="phone-header">
            <div className="profile">
              <div className="user-name">
                {loginInfo?.data?.un ? (
                  <h6>Hey, {loginInfo?.data?.un}</h6>
                ) : (
                  <h6>Hey !</h6>
                )}
              </div>
              {isMobile ? (
                <div className="city-dropdown show-in-mobile-view">
                  <Cities />
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="side-icon">
              {/* <div
                className="search-icon-m"
                onClick={() => {
                  navigate("/m.search");
                }}
              >
                <img src={searchm} alt="" className="img-fluid" />
              </div> */}
              {/* <div className="search-icon-m">
              <img src={qrm} alt="" className="img-fluid" />
            </div> */}
              <div className="search-icon-m">
                <div
                  onClick={() => {
                    if (token) {
                      // setVisible(true);
                      //navigate('/m.profile')
                      setLogoutModal(true);
                    } else {
                      dispatch(setLoginViewMode({ value: true }));
                    }
                  }}
                >
                  <img src={user} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="">
        <Dialog
          header=""
          visible={loginVewMode}
          // modal={false}
          showHeader={false}
          showCloseIcon={false}
          onHide={() => dispatch(setLoginViewMode({ value: false }))}
          className="register-mobile"
        >
          <div className="row">
            <Login />
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default Navbar;
